import React from "react"
import Dropdown from "../../../components/Dropdown/Dropdown"
import { FILTER_CONTROL } from "./filterControlClass"

/**
 * AffiliateFilter component for selecting affiliate to filter by
 * @param {string} selectedAffiliate - Currently selected affiliate ID
 * @param {function} setSelectedAffiliate - Setter for selected affiliate
 * @param {array} affiliates - List of affiliates { value, label }
 * @param {boolean} loading - Loading state
 */
const AffiliateFilter = ({ selectedAffiliate, setSelectedAffiliate, affiliates = [], loading = false }) => {
  const menuItems = [
    { value: '', label: 'All Affiliates' },
    ...affiliates
  ]

  return (
    <Dropdown
      value={selectedAffiliate}
      setValue={setSelectedAffiliate}
      menuItems={menuItems}
      placeholder="Select affiliate"
      ariaLabel="Filter by affiliate"
      className={`w-[200px] ${FILTER_CONTROL}`}
    />
  )
}

export default AffiliateFilter
